$(document).ready(function(){

$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots:false,
  fade: false,
  asNavFor: '.slider-nav',
  responsive: [ {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
});
$('.slider-nav').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,  
  arrows: false,
  centerMode: false,
  focusOnSelect: true
});

$('.slider-for').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $('.pagingInfo').text(i + ' / ' + slick.slideCount);
  });  
/*
if (variant.featured_image) {
  var variantImagePos = variant.featured_image.position - 1;
  $('.slider-for').slick('slickGoTo', variantImagePos);
}*/
  

  
$('.tab-a').click(function(){  
      $(".tabinfo").removeClass('tab-active');
      $(".tabinfo[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
      $(".tab-a").removeClass('active-a');
      $(this).parent().find(".tab-a").addClass('active-a');
     });


$('.images-with-text__buttons--with-second-button-link a.link[aria-label="Full ingredients list"]').attr('href', 'javascript:void(0)');
  
$('.images-with-text__buttons--with-second-button-link a.link[aria-label="Full ingredients list"]').click(function(){  
  $(".ingredients-popup-section").fadeIn();
});
$('.cls_popup, .popup_over').click(function(){  
  $(".ingredients-popup-section").fadeOut();
});

$('.MarbleCap-link').click(function(){  
  $(".marbleCap_popup").fadeIn('fast');
  $(".marbleCap_popup-hover").fadeIn('fast');
});
  $('.marbleCap_popup-hover, .mpop_cls').click(function(){  
  $(".marbleCap_popup").fadeOut('fast');
  $(".marbleCap_popup-hover").fadeOut('fast');
});

$('.ing_poplink').click(function(){    
  $(this).next('.ingredient-popup').fadeIn('fast');
}); 
  $('.cls_ingpopup').click(function(){    
  $('.ingredient-popup').fadeOut('fast');
});

/*
  $('.bsub-widget__plan-header').click(function(){    
  $('.bsub-options-container').addClass('hide');
   
}); 
  $('.bsub-widget__group-header').click(function(){    
  $('.bsub-options-container').removeClass('hide');
   //$('.bsub-options-container').toggleClass('hide2');
}); */


$('.img_item_1').hover(function(){   
   $('.ingredient-textbox').not('.text_item_1').removeClass('active');
  $('.text_item_1').addClass('active');
});  
  $('.img_item_2').hover(function(){    
     $('.ingredient-textbox').not('.text_item_2').removeClass('active');
  $('.text_item_2').addClass('active');
}); 
  $('.img_item_3').hover(function(){    
     $('.ingredient-textbox').not('.text_item_3').removeClass('active');
  $('.text_item_3').addClass('active');
}); 
  $('.img_item_4').hover(function(){    
     $('.ingredient-textbox').not('.text_item_4').removeClass('active');
  $('.text_item_4').addClass('active');
}); 

  
$(document).on('click', '.bsub-widget__plan-header', function(){
  var subprice = $(this).find("span[data-bsub-per-delivery-price]").html();
//alert(subprice);
    $('.product-form__btns .product-price__current-price').html(subprice);
});


 $('.bsub-option-container[data-bsub-option="Every 6 months"] label').trigger('click'); 
$(document).on('click', 'div.bsub-widget__group + .bsub-widget__group', function(){
 
$('.bsub-option-container[data-bsub-option="Every 6 months"] label').trigger('click');
 
});  
  
 });

